import { render, staticRenderFns } from "./copyFooter.vue?vue&type=template&id=2fb9b8ba&scoped=true"
import script from "./copyFooter.vue?vue&type=script&lang=js"
export * from "./copyFooter.vue?vue&type=script&lang=js"
import style0 from "./copyFooter.vue?vue&type=style&index=0&id=2fb9b8ba&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb9b8ba",
  null
  
)

export default component.exports